module.exports = __webpack_public_path__ + "static/macbook-310f382380a2add65bc0586d9776aecc.png";